/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux';
import { RootState } from '../configureStore';
import { CaseTemplate } from '../../data/types';

export type CaseTemplateState = {
    caseTemplates: CaseTemplate[],
}

export const useCaseTemplateState = () => {
    const caseTemplateState = useSelector((state: RootState | any) => state.caseTemplates as CaseTemplateState);
    return caseTemplateState;
}

// Define the initial state using that type
const initialState: CaseTemplateState = {
    caseTemplates: [],
}

export const caseTemplateSlice = createSlice({
    name: 'caseTemplates',
    initialState: initialState,
    reducers: {
        setCaseTemplatesAction: (state, action: PayloadAction<CaseTemplate[]>) => {
            state.caseTemplates = action.payload;
        },
        addOrReplaceCaseTemplateAction: (state, action: PayloadAction<CaseTemplate>) => {
            const existingIndex = state.caseTemplates.findIndex((ct: CaseTemplate) => ct?.templateId === action.payload.templateId);
            if (existingIndex >= 0) {
                state.caseTemplates[existingIndex] = action.payload;
            } else {
                state.caseTemplates.push(action.payload);
            }
        },
        deleteCaseTemplateAction: (state, action: PayloadAction<string>) => {
            state.caseTemplates = state.caseTemplates.filter((x) => x.templateId !== action.payload);
        },
    }
})

export const { addOrReplaceCaseTemplateAction, setCaseTemplatesAction, deleteCaseTemplateAction } = caseTemplateSlice.actions;

export default caseTemplateSlice.reducer;